import { render, staticRenderFns } from "./business-push-message.vue?vue&type=template&id=24a318b5&scoped=true"
import script from "./business-push-message.vue?vue&type=script&lang=js"
export * from "./business-push-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a318b5",
  null
  
)

export default component.exports